/**
 * Render an ISO-8601 timestamp in the user's local time zone for display.
 *
 * Wave 1 rendered `last_verified_at` / `token_expires_at` verbatim - that
 * looks like UTC to a Brisbane user. SRA003-139 §5.1 swaps to
 * `Intl.DateTimeFormat` with the browser TZ (resolvedOptions().timeZone)
 * and an `Australia/Brisbane` fallback (HarvestMate is AU-only per master
 * plan, ratification §9 Q3).
 */
export function formatLocalTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const tz =
    Intl.DateTimeFormat().resolvedOptions().timeZone || 'Australia/Brisbane';
  const date = new Intl.DateTimeFormat('en-AU', {
    timeZone: tz,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d);
  const time = new Intl.DateTimeFormat('en-AU', {
    timeZone: tz,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(d);
  return `${date} at ${time}`;
}
